<template>
  <div class="mission-section">
    <div class="container-fluid px-0">
      <div class="row justify-content-center align-items-center m-0">
        <div class="col-12 col-lg-6 mission-image">
        </div>

        <div class="col-12 col-lg-6 mission-content">
          <h2 class="section-title-mission">MŪSŲ MISIJA</h2>
          <div class="section-divider-mission"></div>
          <div class="mission-text">
            <p class="mission-paragraph">
              Tikime savo paslaugų kokybe ir aptarnaujame visus klientus nesvarbu ar tai būtų individualūs žmonės ar įmonės.
            </p>
            <p class="mission-paragraph">
              Teikiame pilną galimą paslaugų spektrą statybos sektoriuje – žemės kasimas, žemės lyginimo darbai, tvenkinių kasimas,
              sklypo formavimas, griovimo darbai ir visos statybinės technikos bei statybinių transporto priemonių nuoma.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Vizija"
}
</script>

<style scoped>
.mission-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 80px 20px;
}

.mission-image {
  background-image: url('../../assets/traktorius.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 500px;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  margin-bottom: 40px;
  transition: transform 0.3s ease;
}

.mission-image:hover {
  transform: scale(1.02);
}

.mission-content {
  padding: 40px;
}

.section-title-mission {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 20px;
  text-align: center;
}

.section-divider-mission {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  border-radius: 2px;
  margin: 0 auto 30px;
}

.mission-text {
  text-align: left;
}

.mission-paragraph {
  font-family: 'Open Sans', sans-serif;
  font-size: 1.1rem;
  line-height: 1.8;
  color: #6c757d;
  margin-bottom: 20px;
}

.mission-paragraph:last-child {
  margin-bottom: 0;
}

@media (max-width: 992px) {
  .mission-section {
    padding: 60px 15px;
  }
  
  .mission-content {
    padding: 20px;
    text-align: center;
  }
  
  .mission-text {
    text-align: center;
  }
  
  .mission-image {
    min-height: 400px;
  }
}
</style>